// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"197":"3042ee710b86d635","810":"b52f58f85647da88"}[chunkId] + ".js";
};